import {Route, Routes} from 'react-router-dom';

import {Agreements} from './quan-ly-hop-dong';
import {AgreementTemplates} from './mau-hop-dong';
import {AgreementDetail} from './quan-ly-hop-dong/AgreementDetail';



export const Contract = () => {

  return (
    <Routes>
      <Route path="quan-ly-hop-dong" element={<Agreements />}/>
      <Route path="quan-ly-hop-dong/them-moi" element={<Agreements  beCreate={true}/>}/>
      <Route path="mau-hop-dong" element={<AgreementTemplates/>}/>
      <Route path="chi-tiet-hop-dong/:id" element={<AgreementDetail/>}/>
    </Routes>
  );
}
